import PropTypes from 'prop-types'
import { ICON_ORIGINAL_GRAY } from 'constants/colors'

const Mail = ({ color = ICON_ORIGINAL_GRAY, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 13"
    enableBackground="new 0 0 18 13"
    {...props}
  >
    <g>
      <defs>
        <filter
          id="prefix__a"
          filterUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={17.7}
          height={13}
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={17.7}
        height={13}
        id="prefix__b"
      >
        <g filter="url(#prefix__a)">
          <path fill="#fff" d="M0 0v13h17.7V0z" />
        </g>
      </mask>
      <path
        d="M15.5 1.8H2.2l.1.1L8.6 7c.2.2.2.2.5 0l5.1-4.2c.4-.3.8-.7 1.3-1m.4 2c-.1 0-.1 0-.1.1-.5.4-.9.8-1.4 1.2C12.6 6.5 10.8 8 9 9.4c-.1.1-.2.1-.3 0C6.5 7.6 4.2 5.8 2 4c-.1 0-.1-.1-.2-.1s0 .1 0 .2v7c0 .1.1.2.2.2h13.7c.3 0 .3 0 .3-.3V4.1c-.1-.1-.1-.2-.1-.3M8.8 0H17c.4 0 .6.3.6.6v11.7c0 .3-.3.6-.6.6H.6c-.3.1-.6-.2-.6-.6V.6C0 .3.3 0 .6 0h8.2"
        mask="url(#prefix__b)"
        fill={color}
      />
    </g>
  </svg>
)

Mail.propTypes = {
  color: PropTypes.string,
}

export default Mail
